import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetBalanceSheetPayloadType } from "../../commonTypes/reportsTypes";
import LiabilitiesAndAssetsPieChart from "../../components/InsightAdvanced/LiabilitiesAndAssetsPieChart/index";
import SkeltonElement from "../../components/commons/SkeltonLoader/SkeltonElement";
import {
  getBalanceSheetAction,
  resetAssetsBalanceSheetData,
  resetBalanceSheetTotal,
  resetCustomerBalanceSheetData,
  resetEquityBalanceSheetData,
  resetLiabilitiesBalanceSheetData,
  resetPaymentBalanceSheetData,
  resetSupplierBalanceSheetData,
  resetTaxPayableBalanceSheetData,
  resetTaxReceivableBalanceSheetData,
} from "../../redux/reports";
import { BalanceSheetTotalType } from "../../redux/reports/reportsType";
import { RootState } from "../../redux/rootReducers";
import { changeToDecimel } from "../../utils/commonFunctions";

type AppProps = {
  token: string | null;
  history: any;
  currency: string | undefined;
  fetching: boolean;
  balanceSheetTotal: BalanceSheetTotalType;
  dispatchGetBalanceSheetAction: (data: GetBalanceSheetPayloadType) => void;
  dispatchResetCustomerBalanceSheetData: () => void;
  dispatchResetSupplierBalanceSheetData: () => void;
  dispatchResetPaymentBalanceSheetData: () => void;
  dispatchResetEquityBalanceSheetData: () => void;
  dispatchResetAssetsBalanceSheetData: () => void;
  dispatchResetLiabilityBalanceSheetData: () => void;
  dispatchResetTaxPayableBalanceSheetData: () => void;
  dispatchResetTaxReceivableBalanceSheetData: () => void;
  dispatchResetBalanceSheetTotal: () => void;
};
const InsightsBalanceSheetPieChart = ({
  token,
  history,
  balanceSheetTotal,
  currency,
  dispatchGetBalanceSheetAction,
  fetching,
  dispatchResetTaxPayableBalanceSheetData,
  dispatchResetTaxReceivableBalanceSheetData,
  dispatchResetAssetsBalanceSheetData,
  dispatchResetCustomerBalanceSheetData,
  dispatchResetEquityBalanceSheetData,
  dispatchResetLiabilityBalanceSheetData,
  dispatchResetPaymentBalanceSheetData,
  dispatchResetSupplierBalanceSheetData,
  dispatchResetBalanceSheetTotal,
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const [liabilitiesData, setLiabilitiesData] = useState([
    { value: 0, name: "", color: "" },
  ]);
  const [assetsdata, setAssetsData] = useState([
    { value: 0, name: "", color: "" },
  ]);
  const currentYear = new Date().getFullYear();
  const month = new Date().getMonth();
  useEffect(() => {
    dispatchResetAssetsBalanceSheetData();
    dispatchResetSupplierBalanceSheetData();
    dispatchResetLiabilityBalanceSheetData();
    dispatchResetEquityBalanceSheetData();
    dispatchResetCustomerBalanceSheetData();
    dispatchResetPaymentBalanceSheetData();
    dispatchResetTaxPayableBalanceSheetData();
    dispatchResetTaxReceivableBalanceSheetData();
    dispatchResetBalanceSheetTotal();
    let finalData: GetBalanceSheetPayloadType = {
      token,
      client_code,
      date_value: `31-03-${month > 2 ? currentYear + 1 : currentYear}`,
    };

    dispatchGetBalanceSheetAction(finalData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (balanceSheetTotal && Object.keys(balanceSheetTotal).length > 0) {
      let tempLiabilitiesTotal = balanceSheetTotal?.liabilities_total_value;
      let tempSupplierTotal = balanceSheetTotal?.supplier_total_value;
      let tempRetainedEarningTotal = balanceSheetTotal?.net_profit;

      let tempEquityTotal = balanceSheetTotal?.equity_total_value;
      let tempTaxPayableTotal = balanceSheetTotal?.tax_payable_value;
      let tempAssestsTotalValue = balanceSheetTotal?.assets_total_value;
      let tempCustomerTotalValue = balanceSheetTotal?.customer_total_value;
      let tempTaxReceivableTotalValue = balanceSheetTotal?.tax_receivable_value;
      let tempCashAndCashEquivalentsTotalValue =
        balanceSheetTotal?.payment_total_value;
      let tempStockSummaryReportValue =
        balanceSheetTotal?.total_stock_summary_value
          ? balanceSheetTotal?.total_stock_summary_value
          : 0;

      setLiabilitiesData((prev: any) => [
        { value: tempEquityTotal, name: "Equity", color: "#cb8511" },
        {
          value: tempRetainedEarningTotal,
          name: "Retained Earnings",
          color: "#eea834",
        },
        { value: tempLiabilitiesTotal, name: "Liabilities", color: "#fac56d" },
        { value: tempTaxPayableTotal, name: "Tax Payable", color: "#ffdea8" },
        { value: tempSupplierTotal, name: "Supplier", color: "#e3dcd0" },
      ]);
      setAssetsData((prev: any) => [
        { value: tempAssestsTotalValue, name: "Assets", color: "#3949ab" },
        { value: tempCustomerTotalValue, name: "Customer", color: "#5a6acf" },
        {
          value: tempTaxReceivableTotalValue,
          name: "Tax Receivable",
          color: "#8593ed",
        },
        {
          value: +changeToDecimel(+tempStockSummaryReportValue),
          name: "Inventory",
          color: "#ABB4ED",
        },
        {
          value: tempCashAndCashEquivalentsTotalValue,
          name: "Cash & Cash Equivalents",
          color: "#c7ceff",
        },
      ]);
    }
  }, [balanceSheetTotal]);

  const options = {
    responsive: true,
    aria: {
      show: true,
    },
    color: ["#cb8511", "#eea834", "#fac56d", "#ffdea8", "#e3dcd0"],
    tooltip: {
      trigger: "item",
    },
    series: [
      {
        name: "Liabilities",
        type: "pie",
        radius: ["50%", "70%"],
        avoidLabelOverlap: true,
        label: {
          color: "#000",
          fontSize: "12",
          position: "center",
          fontWeight: "600",
          formatter: () => {
            return (
              "Total \n" +
              currency +
              liabilitiesData
                ?.reduce((total, workload) => total + workload.value, 0)
                ?.toFixed(2)
            );
          },
        },
        labelLine: {
          show: false,
        },
        data: liabilitiesData,
      },
    ],
  };

  const assetsOptions = {
    responsive: true,
    aria: {
      show: true,
    },
    color: ["#3949ab", "#5a6acf", "#8593ed", "#c7ceff"],
    tooltip: {
      trigger: "item",
    },
    series: [
      {
        name: "Assets",
        type: "pie",
        radius: ["50%", "70%"],
        avoidLabelOverlap: false,
        label: {
          color: "#000",
          fontSize: "12",
          position: "center",
          fontWeight: "600",
          marginRight: "5px",
          innerWidth: "80px",
          formatter: `Total \n${
            currency +
            assetsdata
              ?.reduce((total, workload) => total + workload.value, 0)
              ?.toFixed(2)
          }`,
        },
        labelLine: {
          show: false,
        },
        data: assetsdata,
      },
    ],
  };
  return (
    <>
      <div className=" d-flex" style={{ gap: "2%" }}>
        {fetching ? (
          <SkeltonElement type="bigavatar" />
        ) : (
          <LiabilitiesAndAssetsPieChart
            data={liabilitiesData}
            options={options}
            name="Liabilities"
            currency={currency ? currency : ""}
          />
        )}
        {fetching ? (
          <SkeltonElement type="bigavatar" />
        ) : (
          <LiabilitiesAndAssetsPieChart
            data={assetsdata}
            options={assetsOptions}
            name="Assets"
            currency={currency ? currency : ""}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.reports.fetching,
  error: state.reports.error,
  statusCode: state.reports.statusCode,
  success: state.reports.success,
  balanceSheetTotal: state.reports.balanceSheetTotal,
  currency: state.auth.currencySign,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetBalanceSheetAction: (data: GetBalanceSheetPayloadType) =>
    dispatch(getBalanceSheetAction(data)),
  dispatchResetCustomerBalanceSheetData: () =>
    dispatch(resetCustomerBalanceSheetData()),
  dispatchResetSupplierBalanceSheetData: () =>
    dispatch(resetSupplierBalanceSheetData()),
  dispatchResetPaymentBalanceSheetData: () =>
    dispatch(resetPaymentBalanceSheetData()),
  dispatchResetEquityBalanceSheetData: () =>
    dispatch(resetEquityBalanceSheetData()),
  dispatchResetAssetsBalanceSheetData: () =>
    dispatch(resetAssetsBalanceSheetData()),
  dispatchResetLiabilityBalanceSheetData: () =>
    dispatch(resetLiabilitiesBalanceSheetData()),
  dispatchResetTaxPayableBalanceSheetData: () =>
    dispatch(resetTaxPayableBalanceSheetData()),
  dispatchResetTaxReceivableBalanceSheetData: () =>
    dispatch(resetTaxReceivableBalanceSheetData()),
  dispatchResetBalanceSheetTotal: () => dispatch(resetBalanceSheetTotal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightsBalanceSheetPieChart);
